import {
  SearchHistoryState,
  SearchHistoryActionTypes,
  SEARCH_HISTORY_ADD,
  SEARCH_HISTORY_CLEAR,
  SEARCH_HISTORY_LOADING,
} from './SearchHistory.types';

const defaultState: SearchHistoryState = {
  history: [],
  loading: false,
};

export function searchHistoryReducer(
  state = defaultState,
  action: SearchHistoryActionTypes,
): SearchHistoryState {
  switch (action.type) {
    case SEARCH_HISTORY_CLEAR: {
      return {
        ...defaultState,
      };
    }
    case SEARCH_HISTORY_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case SEARCH_HISTORY_ADD: {
      return {
        ...state,
        history: action.payload,
      };
    }
    default:
      return state;
  }
}
